import { render, staticRenderFns } from "./createCard.vue?vue&type=template&id=3b1488f1&scoped=true"
import script from "./createCard.vue?vue&type=script&lang=js"
export * from "./createCard.vue?vue&type=script&lang=js"
import style0 from "./createCard.vue?vue&type=style&index=0&id=3b1488f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1488f1",
  null
  
)

export default component.exports